export default __webpack_public_path__ + "static/media/Patients_Active.c8d319d5.svg";